module.exports = __webpack_public_path__ + "img/map.ae1d763e.png";